// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"4b1ae41f","492":"109dfc4f"}[chunkId] + ".chunk.js";
};